const distributions = {
  DISTRIBUTION_LABEL: 'Distribuciones',

  DISTRIBUTION_TEMPLATE_NAME: 'Plantilla Plika - Distribución ({{date}})',
  DISTIBUTION_DOWNLOAD_TEMPLATE_INFORMATIVE_TOOLTIP_TITLE:
    'Debes elegir un tipo de presupuesto y al menos un valor de dimension para poder descargar',
}

export default distributions
